import Head from 'next/head';

import { ComponentProps } from 'src/types/component-props';

import { CoreMetadataSearchBloxData } from '../../../types/components';

export type CoreMetadataSearchBloxProps = ComponentProps & CoreMetadataSearchBloxData;

const CoreMetadataSearchBlox = (props: CoreMetadataSearchBloxProps): JSX.Element => {
  const {
    site,
    postTitle,
    postId,
    postType,
    publishedDate,
    lastModifiedDate,
    alphaSort,
    sortDate,
    lastNameLetter,
    barAdmissions,
    lawyerLevel,
    contentTypes,
    relatedPeople,
    relatedOffices,
    relatedServices,
  } = props.fields;

  return (
    <Head>
      <meta name="oni_site" content={site} />
      <meta name="oni_posttitle" content={postTitle.toString()} />
      <meta name="oni_postid" content={postId.toString()} />
      <meta name="oni_posttype" content={postType} />
      <meta name="oni_publisheddate" content={publishedDate} />
      <meta name="lastmodified" content={lastModifiedDate} />
      <meta name="oni_alphasort" content={alphaSort} />

      {sortDate && <meta name="oni_sortdate" content={sortDate} />}
      {lastNameLetter && <meta name="oni_lastnameletter" content={lastNameLetter} />}
      {barAdmissions && <meta name="oni_baradmissions" content={barAdmissions.join(',')} />}
      {lawyerLevel && <meta name="oni_lawyerlevel" content={lawyerLevel.toString()} />}
      {contentTypes && <meta name="oni_contenttypes" content={contentTypes.join(',')} />}
      {relatedPeople && <meta name="oni_relatedpeople" content={relatedPeople.join(',')} />}
      {relatedOffices && <meta name="oni_relatedoffices" content={relatedOffices.join(',')} />}
      {relatedServices && <meta name="oni_relatedservices" content={relatedServices.join(',')} />}
    </Head>
  );
};

export default CoreMetadataSearchBlox;
